/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompositionGroupDto } from './compositionGroupDto';


export interface CompositionDto { 
    id?: number;
    name?: string | null;
    priority?: number;
    compositionGroups?: Array<CompositionGroupDto> | null;
}

